import styled from 'styled-components';

export const WorkspaceRoot = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface};
`;

export const ChatColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
`;

export const ChatBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
`;

export const ChatFooter = styled.div`
  display: flex;
  flex: none;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  min-height: 64px;
  padding: 0 14px;
  border-top: 1px solid ${({ theme }) => theme.colors.outlineVariant};
`;

export const ChatFooterHint = styled.span`
  flex: 1 1 auto;
  min-width: 0;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.onSurfaceVariant};
`;
